export const ESCALATOR_DISTANCE = 200
export const RAMP_DISTANCE = 200
export const ELEVATOR_DISTANCE = 500
export const STAIR_DISTANCE = 999999
export const STAIR_EMERGENCYEXIT_DISTANCE = 1000000
export const BASE_POI_DISTANCE = 9999999

export const OBSTACLE_FEATURE_TYPES = ["kiosk" /* , "fixture" */]
export const OBSTACLE_CATEGORIES = [
  "fixture.water",
  "fixture.stage",
  "nonpublic",
  "opentobelow",
  "elevator",
  "escalator",
  "stairs",
  "stairs.emergencyexit",
  "room",
  "unspecified",
  "structure",
  "brick",
  "concrete",
  "drywall",
  "glass",
  "wood",
  "column",
]
// Walkable category should be further update in the future
export const WALKABLE_CATEGORY = [
  "walkway",
  "steps",
  "parking",
  "room",
  "terrace",
  "unenclosedarea",
  "vegetation",
  "unspecified",
]
